import { Component, ElementRef, AfterViewInit, ViewChild, EventEmitter, Input, HostListener, Output, ViewContainerRef, ChangeDetectorRef } from '@angular/core';
import * as moment from 'moment';
import { AgGridAngular } from 'ag-grid-angular';
import { GridOptions } from "ag-grid-community";
import { DriveServiceProvider } from '../../providers/drive-service/drive-service';
import { ConfigureServiceProvider } from '../../providers/configure-service/configure-service';
import { Events, AlertController, ModalController, ToastController, ViewController, PopoverController, LoadingController } from 'ionic-angular';
import { DriveSharePage } from '../../pages/drive-share/drive-share';
import { ExcelService } from '../../providers/excel-service/excel-service';
import { SchedulerPage } from '../../pages/scheduler/scheduler';
import { StoreWrapProvider } from '../../providers/store-wrap/store-wrap';
import { ButtonRendererComponent } from '../button-renderer/button-renderer';
import { ConfigApiServiceProvider } from '../../providers/config-api-service/config-api-service';
import { AdvanceSearchComponent } from '../../components/form/advance-search/advance-search';
import { ExcelUploadPage } from '../../pages/excel-upload/excel-upload';
import { CommunicationServiceProvider } from '../../providers/communication-service/communication-service';
import { HyperLinkComponent } from '../hyper-link/hyper-link';

declare var jQuery: any;
declare var epcConnect: any;
const OBJLEN = 0;
const mobileWidth = 1366;
enum autoSizeOptions { autoSizeAll = 1, autoSizeAllHeader = 2, sizeFit = 3 }
@Component({
  selector: 'my-grid-application',
  templateUrl: 'my-grid-application.html'
})
export class MyGridApplicationComponent implements AfterViewInit {
  @ViewChild('agGrid', { static: true }) agGrid: AgGridAngular;
  @ViewChild('topGrid', { static: true }) topGrid;
  @ViewChild('bottomGrid', { static: true }) bottomGrid;
  @Input() customHeight: any;
  @Input() templateID: any;
  @Input() params: any;
  @Input() templateManagerGridProps: any;
  @Input() gridStatus: any;
  @Input() gridRowData: any = [];
  @Input() rowDataStatus: any = false;
  @Input() watchTabStatus: boolean = false;
  @Input() visibleRuleEngine: boolean = false;
  @Output() triggerTemplateManager: EventEmitter<any> = new EventEmitter<any>();
  @Input() groupShare: any;
  gridOptions: any = { 'filterChange': true }; //Container to store grid properties and events
  gridOptionsPrint: any = { 'print': true }; //Container to store grid properties and events
  gridApi: any;//GridOptions api store
  columnDefs: any;//Grid column header details
  defaultColDef: any; //Default Properties to be handle in ag grid 
  gridColumnApi: any;//Ag grid column APi data
  rowSelection: any;   //Single selection row/Multiple select row
  documentName: any;//Template Name in the document and file upload
  objPostData: any = {};//Object Json to Add new/Update the row in the grid
  objDeletePostData: any = {};//Object Json to Delete the row in the grid
  frameworkComponents: any;//Array to hold Rendering components
  context: any;//we can access method from parent component in the child component this.params.context.componentParent
  oldValue: any = '';//String to store edited old Value
  newValue: any = '';//String to store edited new Value
  columnId: any = '';//String to store the column name of edited column
  rowNodeIndex: any = 0;//Selected Row Node Index Value
  elem = this.el.nativeElement;//DOM element
  inputElementClicked: any = false;//Flag to maintain the whether the editing column is clicked or not
  rowIndexEditStart: any;//Numeric to store the index of the row which is started to edit
  rowEditStartValue: any = '';//String to store the previous value of the column before starting to add update entries
  rowIndexEditStop: any;//Numeric to store the index of the row which was edited and stopped
  rowEditStopValue: any = '';//String to store the Value of the column which was edited and stopped
  // public modules: Module[] = AllCommunityModules;
  topOptions = { alignedGrids: [], suppressHorizontalScroll: true };
  bottomOptions = { alignedGrids: [] };
  quickSearchValue: string = '';
  paginationPageSize: any = 12;
  paginationNumberFormatter;
  pageSize: any = 100;
  pagination: any = true;
  changedRowNode: any = [];
  detailId: any = "";
  actionStatus: string = "update";
  defaultHeight: boolean = true;
  currentScreenProps: any;
  filterparams: any = {};
  rowIndex: any;
  rowselectedLength: any = 0;
  gridAllRows: any = {};
  broadcastSubs: any;
  selectedRow: any;
  // filterChange:boolean;
  @Input() set screenProps(v: any) {
    if (v) {
      this.currentScreenProps = {};
      this.currentScreenProps = v;
    }
  }
  tntActiveStatus: any;
  pvEvents: any;
  pvDriveService
  show: boolean = false;
  gridReSize: boolean = false;
  agGridMobileView: boolean = false;
  paramId: any;
  selectedSize: any = '';
  templateColProps: any = [];
  templateManagercontrolState: any = false;
  templateColProp: any = [];
  agGridDynamicStyle: any = '';
  selectedGirdRow: any = '';
  gridSizeAdjustMenu: any = this.driveServiceProvider.adminAccess;
  skipHeader: any = '';
  inlineEditAccess: any;
  min_window: boolean = false;
  screenResolution: number = 1366;
  mobilView: boolean = false;
  headerWidth: any;
  arrTemplates: any = [];
  arrTemplateFields: any = [];
  tempFields: any;
  tempFieldProperties: any = []
  gridHieght: string;
  advanceSearchEnable: boolean = false;
  newRulearr: any = [];
  newRuleLength: any = 0;
  WorkflowID: any;
  loadMoreIcon: any;
  isLoadMoreClick: boolean = false;
  version_modal: boolean;
  toggleVersion: boolean;
  timesheet: any;
  versionHistoryComponentName: any;
  versionHistoryFormGridProps: any = [];
  versionHistoryDefaultFormProps: any = [];
  paramData: any;
  versionHistoryProps: any = [];
  templateId: any;
  showOpen: boolean = false;
  searchFlag: any;
  row_index: any;
  private noRowsTemplate;
  private loadingTemplate;
  loader: any;

  private sortingOrder;
  @Output("chatTntActivity") chatTntActivity: EventEmitter<any> = new EventEmitter();

  constructor(public loadingController: LoadingController,private popoverCtrl: PopoverController, public cdRef: ChangeDetectorRef, public communicationServ: CommunicationServiceProvider, public configureService: ConfigureServiceProvider, public excelService: ExcelService, public configApiService: ConfigApiServiceProvider, private el: ElementRef, private driveServiceProvider: DriveServiceProvider, private storeWrap: StoreWrapProvider, public events: Events, private alertCtrl: AlertController, private modal: ModalController, private toastCtrl: ToastController) {
    this.pvDriveService = this.driveServiceProvider;
    this.pvEvents = events;
    this.loadingTemplate = `<span class="ag-overlay-loading-center"> <i class="fa fa-spinner fa-spin"></i> Please Wait...</span>`;
    this.noRowsTemplate = `<span">No Rows To Show</span>`;
    this.sortingOrder = ['asc', 'desc'];
  }

  fetchScreenProps() {
    if (!this.currentScreenProps) {
      this.currentScreenProps = this.driveServiceProvider.storeWrap.storeTemplates[this.templateID];
    }
  }

  /*********
   * Auto resize Grid 
   */

  autoSizeAll(skipHeader) {
    if (skipHeader == 'autoSizeAll') {
      this.skipHeader = false;
      this.selectedSize = autoSizeOptions.autoSizeAll;
    } else if (skipHeader == 'autoSizeAllHeader') {
      this.skipHeader = true;
      this.selectedSize = autoSizeOptions.autoSizeAllHeader;
    } else if (skipHeader == 'sizeFit') {
      this.selectedSize = autoSizeOptions.sizeFit;
    }
    this.autoSizeAllSubmit()
  }
  autoSizeAllSubmit() {

    if (this.selectedSize == autoSizeOptions.sizeFit) {
      this.gridOptions.gridApi.sizeColumnsToFit();
      this.gridReSize = false;
      return;
    }
    if (this.skipHeader === '') {
      this.saveCurrentSettings(this.gridOptions)
    } else {
      var allColumnIds = [];
      this.gridOptions.columnApi.getAllColumns().forEach(function (column) {
        allColumnIds.push(column.colId);
      });
      this.gridOptions.columnApi.autoSizeColumns(allColumnIds, this.skipHeader);
    }
    this.gridReSize = false;
    this.selectedSize = '';
    this.skipHeader = '';
  }

  saveCurrentSettings(gridOptions) {
    this.templateColProp = [];
    gridOptions.api.columnController.allDisplayedColumns.forEach(element => {
      let colPropsData = {
        "headerName": element.userProvidedColDef.headerName,
        "field": element.userProvidedColDef.field,
        "width": element.actualWidth,
        "cellRenderer": element.userProvidedColDef.cellRenderer,
        "cellRendererParams": element.userProvidedColDef.cellRendererParams,
        "sort": element.sort
      }
      this.templateColProp.push(colPropsData);
    });
    let apiLoadData = {
      "screen": this.templateID,
      "colprops": this.templateColProp,
      "userid": this.configureService.getLoginUserID(),
      "client": this.configureService.getStudio(),
      "app_code": this.configApiService.currentDriveApp['app_code']
    }

    var objData = Object.assign({}, this.configApiService.driveApi.setGridprops.params, apiLoadData)
    this.configApiService.customRequest(this.configApiService.setGridPropsApi, objData, this.submitGridProps)
  }
  submitGridProps = ((resdata) => {

    var templateid = this.templateID
    var data = this.storeWrap.storeTemplates[templateid];
    this.driveServiceProvider.storeWrap.storeTemplates[templateid].colprops = this.templateColProp;

    const toast = this.toastCtrl.create({
      message: 'Data Saved Successfully.',
      duration: this.configApiService.toastDuration
    });
    toast.present();
  })

  ngOnDestroy() {
    this.currentScreenProps = [];
    delete this.gridStatus;
    if (this.watchTabStatus == true) {
      this.watchTabStatus = false;
      this.driveServiceProvider.broadcastInfo({ src: 'drive', event: 'tntActiveStatus', status: false });
    }
  }

  ngOnInit() {
    if (window.innerWidth < 700) {
      this.agGridMobileView = true;
      this.mobilView = true;
    }
    if (this.driveServiceProvider.objCurrentFolder.folders.length != 0) {
      this.gridHieght = 'gridHieght';
    } else {
      this.gridHieght = 'gridHeightMobile';
    }
    /* * * * * *
        * Grid Configuration
        * * * * * * */
    if (this.gridStatus == "templateManager") {
      this.driveServiceProvider.objCurrentFolder["template"] = [];
    }
    this.agGridOptionConfiguration(this.pvDriveService);
    if (this.currentScreenProps != undefined) {
      if (this.currentScreenProps.componentName === 'FormGridComponent') {
        this.defaultHeight = false;
        this.pagination = false;
        this.agGridDynamicStyle = 'FormGrid';
      }
    }
    this.loadGridData(this.templateID);
    // this.getAllRules();
    /* * * * * *
    * Event Subscribe Methods
    * * * * * * */
    this.initDriveEvents();

    // this.filterChange = true;
    this.gridOptions.filterChange = true;
    this.gridOptions.print = true;
    this.driveServiceProvider.customObservable.subscribe((res) => {
      this.onQuickFilterChanged();
    })
  }

  loadGridData(templateID) {
    var params = { force: true };
    if (this.gridOptions.gridApi) {
      this.gridOptions.gridApi.setFilterModel(null);
      this.gridOptions.gridApi.refreshCells(params);
      this.gridOptions.gridApi.setRowData([]);
      this.gridOptions.columnDefs = {};
    }

    epcConnect.loadGridTemplate = false;
    epcConnect.colProps = {};
    epcConnect.rowData = {};

    if (!templateID) {
      this.templateManagercontrolState = false;
      if (this.gridStatus == 'templateManager') {
        this.templateManagercontrolState = true;
        this.pagination = false;
        if (this.templateManagerGridProps != undefined) {
          this.templateManagerGridProps["id"];
          this.loadGridTemplateManager(this.templateManagerGridProps);
          this.templateManagercontrolState = true;
          this.pagination = false;
          return
        }
      }

      if (this.driveServiceProvider.objCurrentFolder.template.length != 0) {
        templateID = this.driveServiceProvider.objCurrentFolder.template[0].id;
      }

    }
    if (templateID) {
      let colProps = this.driveServiceProvider.storeWrap.storeTemplates[templateID].colprops;
      const gridStart = 1;
      if (this.groupShare == undefined) {
        this.driveServiceProvider.CurrentFilesData = [];
      }
      this.storeWrap.storeTemplates[templateID].pullParams.start = gridStart;
      this.storeWrap.storeTemplates[templateID].pullParams.end = this.configApiService.gridLength;
      if (this.driveServiceProvider.objCurrentFolder != undefined) {
        if (this.gridRowData.length <= 1 && this.rowDataStatus == false) {
          if (this.driveServiceProvider.CurrentFilesData.length === 0) {
            this.driveServiceProvider.pullSyncData(templateID, this.params, this.driveServiceProvider.objCurrentFolder, this.storeWrap.typeOfApi.summary, this.storeWrap.typeOfData.typeFile, this.getFileData);
          }
        }
      }
    } else {

    }

  }


  /* * * * * *
  * Grid Filters & Sorting 
  * * * * * */
  //**************DATE FORMAT************* */
  dateFormatter(params) {
    if (params.value) {
      return moment(params.value).format('DD-MMM-YYYY');
    } else {
      return params.value;
    }
  }

  //************** Date Filter ****************//
  filterDate(filterLocalDateAtMidnight, cellValue) {
    var dateAsString = cellValue;
    if (dateAsString == null) return 0;
    var dateParts = dateAsString.split("-");
    var day = Number(dateParts[2]);
    var month = Number(dateParts[1]) - 1;
    var year = Number(dateParts[0]);
    var cellDate = new Date(year, month, day);
    if (cellDate < filterLocalDateAtMidnight) {
      return -1;
    } else if (cellDate > filterLocalDateAtMidnight) {
      return 1;
    } else {
      return 0;
    }
  }

  //************** Date sorting ****************//
  dateComparator = ((date1, date2) => {
    var date1Number = this.monthToComparableNumber(date1);
    var date2Number = this.monthToComparableNumber(date2);
    if (date1Number === null && date2Number === null) {
      return 0;
    }
    if (date1Number === null) {
      return -1;
    }
    if (date2Number === null) {
      return 1;
    }
    return date1Number - date2Number;
  });

  monthToComparableNumber(date) {
    if (date === undefined || date === null || date.length !== 10) {
      return null;
    }
    var dateArr = date.split('-');
    var yearNumber = dateArr[0];
    var monthNumber = dateArr[1];
    var dayNumber = dateArr[2];
    var result = yearNumber * 10000 + monthNumber * 100 + dayNumber;
    return result;
  }


  /********************************************* */
  initGridHeader(colProps) {
    let isEditable = false;
    if (colProps != undefined) {
      for (var i = 0; i < colProps.length; i++) {
        for (var rowidx = 0; rowidx < this.currentScreenProps.formLayout.length; rowidx++) {
          for (var colidx = 0; colidx < this.currentScreenProps.formLayout[rowidx].length; colidx++) {
            var field = this.currentScreenProps.formLayout[rowidx][colidx].fields.find(elem => elem.FieldName == colProps[i].field);
            if (field && field.FieldDataType == "DATE") {
              colProps[i]["filter"] = 'agDateColumnFilter'; //Ag-grid Date Filter 
              colProps[i].comparator = this.dateComparator //date sorting
              colProps[i]['filterParams'] = { comparator: this.filterDate } //Ag-grid Date Filter
              // colProps[i].valueFormatter = this.dateFormatter;//Date Format
            } else if (field && field.FieldDataType == "DECIMAL") {
              colProps[i]["filter"] = 'agNumberColumnFilter'; //Ag-grid Decimal Filter 
              //colProps[i]["type"] = 'numericColumn'; //Ag-grid Decimal field right align
            } else if (field && field.FieldDataType) {
              colProps[i]['FieldDataType'] = field.FieldDataType;//Date Format
            }
          }
        }
        isEditable = colProps[i].editable || isEditable;

      }
      this.gridOptions.suppressPropertyNamesCheck = true;
      // this.gridOptions.columnDefs.rowGroup = true;
      // this.gridOptions.columnDefs.enableValue = true;
      this.gridOptions.columnDefs = colProps;
      this.topOptions.alignedGrids.push(this.bottomOptions);
      this.bottomOptions.alignedGrids.push(this.topOptions);
      // if (this.currentScreenProps.componentName !== 'FormGridComponent') {
      this.toHideGridColumns()
      let existAction: any = this.gridOptions.columnDefs.find(item => item.headerName == "Action");
      if (!existAction) {
        this.gridOptions.columnDefs.unshift({
          headerName: "Action", filter: false, cellRenderer: 'buttonRenderer', cellRendererParams: {
            onClick: this.clickNav.bind(this),
            label: 'Click 1'
          },
        });
      }
      else {
        existAction.cellRendererParams['onClick'] = this.clickNav.bind(this);
      }
      // }
      this.gridOptions.columnDefs[0]['lockPosition'] = true; //flag for lock position
      this.gridOptions.columnDefs[0]['cellClass'] = "locked-col";
      this.gridOptions.columnDefs[0]['pinned'] = "left"; //Pinning column Position
      this.gridOptions.columnDefs[0]['lockPinned'] = true; //flag for pinning position
      if (isEditable == true) {
        let existAction: any = this.gridOptions.columnDefs.find(item => item.headerName == "Action");
        if (!existAction) {
          this.gridOptions.columnDefs.push({
            headerName: "Action",
            cellRenderer: 'buttonRenderer',
            cellRendererParams: {
              onClick: this.updateData.bind(this),
              label: 'Click 1'
            },
          });
        } else {
          existAction.cellRendererParams['onClick'] = this.updateData.bind(this);
        }
      }
    }
  }

  /* * * * * *
  * Grid Configuration
  * * * * * * */
  agGridOptionConfiguration(driveService) {
    this.gridEvents(driveService);
    this.rowSelection = "multiple";
    this.paginationNumberFormatter = function (params) {
      return "[" + params.value.toLocaleString() + "]";
    };
    this.gridOptions.columnDefs = [];
    this.gridOptions.rowData = [];

    if (driveService.objCurrentFolder["template"].length > 0) {
      let colProps: any = [];
      /* * * * * * *
      * code for Grid current template colProps load 
      * * * * * * */
      this.fetchScreenProps();

      colProps = this.currentScreenProps.colprops;

      this.initGridHeader(colProps);
    }

    this.gridOptions.rowData = [];
    /* * * * * * *
    * code for Grid current template rowData load 
    * * * * * * */
    this.defaultColDef = {
      width: 100,
      sortable: true,
      resizable: true,
      filter: true,
      enableRowGroup: true,
      enableValue: true,
      onCellClicked: this.rowSingleClicked.bind(this),
      headerCheckboxSelectionFilteredOnly: true,
      headerCheckboxSelection: params => {
        const displayedColumns = params.columnApi.getAllDisplayedColumns();
        return displayedColumns[0] === params.column;
      },
      checkboxSelection: params => {
        const displayedColumns = params.columnApi.getAllDisplayedColumns();
        return displayedColumns[0] === params.column;
      },
      // cellRenderer: function (params) {
      // console.log('cellRender', params)
      // if (params.colDef["FieldDataType"] == "HYPERLINK") {
      //   return `<a href ='${params.value}' target="_blank">` + params.value + `</a>`
      // } else {
      //   if (params.value !== null && params.value != undefined) {
      //     if (typeof params.value == "string") {
      //       var paramsStrValue = params.value
      //     } else {
      //       paramsStrValue = params.value.toString()
      //     }
      //     var dataLink = paramsStrValue.split('=')
      //     if (dataLink[0] == "<a href") {
      //       var linkData = dataLink[1].split('>')
      //       return `<a href ='${JSON.parse(linkData[0])}' target="_blank">` + JSON.parse(linkData[0]) + `</a>`
      //     } else {
      //       return params.value
      //     }
      //   } else {
      //     return params.value
      //   }
      // }

      // }
    };

    this.topOptions.alignedGrids.push(this.bottomOptions);
    this.bottomOptions.alignedGrids.push(this.topOptions);
    this.context = { componentParent: this };
    this.frameworkComponents = {
      buttonRenderer: ButtonRendererComponent,
      hyperLinkRenderer: HyperLinkComponent
    }
  }

  gridEvents(driveService) {
    var _this = this;
    this.gridOptions = <GridOptions>{
      onColumnResized: function (event) {
        this.headerWidth = event.api;
      },

      onGridReady: function (event) {
        this.gridApi = event.api;
        event.api.showLoadingOverlay();
        this.gridApi.refreshHeader();
        for (let i = 0; i < driveService.objCurrentFolder["template"].length; i++) {
          if (driveService.objCurrentFolder["template"][i]["filterParams"] != undefined) {
            if (Object.keys(driveService.objCurrentFolder["template"][i]["filterParams"]).length > 0) {
              for (let m in driveService.objCurrentFolder["template"][i]["filterParams"]) {
                let filterParamInstance: any;
                filterParamInstance = this.gridApi.getFilterInstance(m);
                if (filterParamInstance != undefined) {
                  filterParamInstance.setModel(driveService.objCurrentFolder["template"][i]["filterParams"][m]);
                  this.gridApi.onFilterChanged();
                }

              }
            }
          }
        }
        let pushArray = [];
        if (_this.rowDataStatus == true && _this.gridRowData.length > 0) {
          pushArray.push(_this.gridRowData);
        } else if (driveService.CurrentFilesData.length !== 0) {
          pushArray.push(driveService.CurrentFilesData)
        }
        if (pushArray.length != 0) {
          _this.setGridData(pushArray);
        }
        var data = driveService.objCurrentFolder
        if (data !== undefined) {
          if (data.files[0] !== undefined) {
            var rowData = data.files[0]
            if (rowData !== undefined) {
              if (rowData && rowData.length > 0) {
                // event.api.showLoadingOverlay()
              } else {
                event.api.showNoRowsOverlay()
              }
            }
          }
        }
      },

      onFilterChanged: function (event) {
        this.filterParams = event.api.getFilterModel();
        if (Object.keys(this.filterParams).length == 0) {
          this.filterChange = true;
        } else {
          this.filterChange = false;
        }
      },

      onFilterModified: function (event) {

      }

    };

  }

  onGridReady(params) {

    params.api.sizeColumnsToFit();
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  /* * * * *
  * New Empty Row Insert
  * * * * */
  addNewRow() {
    var newItem = this.createNewRowData();
    this.gridOptions.rowData.splice(0, 0, newItem);
    this.gridOptions.gridApi.setRowData(this.gridOptions.rowData);
  }

  createNewRowData() {
    var columnEmptyValueField = {};
    this.gridOptions.columnDefs.map(function (fieldIndex, index) {
      if (fieldIndex['field']) {
        columnEmptyValueField[fieldIndex['field']] = '';
      }
    })
    return columnEmptyValueField;
  }

  successInsert(res) {
    if (res.add) {
      res.add.forEach(function (rowNode) {

      });
    }
    if (res.remove) {
      res.remove.forEach(function (rowNode) {

      });
    }
    if (res.update) {
      res.update.forEach(function (rowNode) {

      });
    }
  }
  /***************************************************** */


  /* * * * * * *
   * Row Selected
   * * * * * * */
  rowSelected(params) {
    let selectedFile = [];
    this.selectedRow = params;
    if (this.currentScreenProps.componentName == 'FormGridComponent' && params.data.length != 0) {
      selectedFile.push(params.data)
    } else {
      selectedFile = this.gridOptions.gridApi.getSelectedRows();
    }
    this.rowselectedLength = selectedFile.length;
    const rowLength = 1;
    if (selectedFile.length == rowLength) {
      this.showOpen = true;
    } else {
      this.showOpen = false;
    }
    if (this.currentScreenProps.componentName != 'SUMMARY') {
      if (this.currentScreenProps.colprops.find(col => col.editable == true)) {

        this.elem.querySelectorAll(".ag-row-focus .button").forEach(el => el.disabled = false);
        this.elem.querySelectorAll(".ag-row-no-focus .button").forEach(el => el.disabled = true);
        this.elem.querySelectorAll(".ag-row-focus .clearRow ion-icon")[0].style.color = "red";
        this.elem.querySelectorAll(".ag-row-no-focus ion-icon").forEach(el => el.style.color = "gray");
      }

      if (this.rowIndexEditStop != undefined) {
        if (this.rowIndexEditStop != params.rowIndex) {
          let rowNode: any;
          rowNode = this.gridOptions.gridApi.getRowNode(this.rowIndexEditStop);
          rowNode.setDataValue(this.columnId, this.rowEditStartValue);
        }
      }
    }
  }


  /* * * * * *
   * Row Data Double Click open Component/Edit
   * * * * * */
  rowDoubleClicked(e) {
    if (this.currentScreenProps.componentName != 'SUMMARY') {
      if (this.currentScreenProps.colprops.find(col => col.editable == true)) {
      } else {
        this.driveServiceProvider.broadcastInfo({ src: 'drive-main', event: 'showComponentHolder', status: true });
        this.openTemplateComponents(e);
      }
      this.selectedGirdRow = e;
    }
  }

  openTemplateComponents(e) {
    let clickRowIndex = e.rowIndex, sourceKey: any, componentName: any, accesstype: any, templateName: any;

    let arrTemplateProps = [];
    let gridAllRowsData = [];
    gridAllRowsData = JSON.parse(this.gridAllRows)
    if (this.driveServiceProvider.objCurrentFolder.template.length) { // changing the validation to 1 from >1
      for (let idx = 0; idx < this.driveServiceProvider.objCurrentFolder.template.length; idx++) {
        arrTemplateProps.push(this.driveServiceProvider.storeWrap.storeTemplates[this.driveServiceProvider.objCurrentFolder.template[idx].id]);
      }
    }
    else {
      sourceKey = this.currentScreenProps['sourceKey'];
      componentName = this.currentScreenProps['componentName'];
      accesstype = this.currentScreenProps['accessType'];
      templateName = this.currentScreenProps['templateName'];

    }

    let selectedRows = [];
    if (e.data.length != 0) {
      selectedRows.push(e.data);
    }
    // this.gridOptions.api.getSelectedRows();
    let selectedRowsString = {};
    let statusFlag = false;

    if (selectedRows.length == 1) {
      selectedRowsString = selectedRows[0];
    } else if (selectedRows.length > 1) {
      selectedRows.forEach((selectedRow, index) => {
        if (index !== 0) {
          selectedRowsString = {};
        }
        selectedRowsString = selectedRow;
      });
    }
    localStorage.setItem('RowData', JSON.stringify(selectedRowsString));
    setTimeout(() => {
      epcConnect.destoryCKEditor = true;

      if (this.currentScreenProps.componentName === 'FormGridComponent') {
        this.driveServiceProvider.broadcastInfo({ src: 'form-grid', event: 'loadComponentCurrentData', templates: this.driveServiceProvider.objCurrentFolder.template, params: selectedRowsString });
      } else if (this.currentScreenProps.componentName === "SUMMARY") {

        this.driveServiceProvider.broadcastInfo({ src: 'form-grid', event: 'loadComponentCurrentData', templates: this.driveServiceProvider.objCurrentFolder.template, params: selectedRowsString });

      } else {
        // this.events.publish('utilizationReport', true, this.configApiService.driveApi)
        this.driveServiceProvider.broadcastInfo({ src: 'compLoad', event: 'triggerComponentLoad', status: 'editdata', item: arrTemplateProps, param: selectedRowsString, allrows: gridAllRowsData });
      }
      if (componentName == "FileUploadPage") {
        this.documentName = selectedRows[0]['Name'];
        this.driveServiceProvider.broadcastInfo({ src: 'grid', event: 'documentName', documentName: this.documentName });
      }


    }, 300);
  }
  /***************************************************************/
  /********************** */
  /* * * * * * * * *
   * Cell Editing Started
   * * * * * * * * */
  cellEditingStarted(params) {
    this.rowIndexEditStart = params.rowIndex;
    this.rowEditStartValue = params.value;
    this.elem.querySelectorAll(".ag-row-focus .saveRow ion-icon")[0].style.color = "green";
    this.inputElementClicked = true;
  }

  /* * * * * * * * *
   * Cell Editing Stopped
   * * * * * * * * */
  cellEditingStopped(params) {
    this.rowIndexEditStop = params.rowIndex;
    this.rowEditStopValue = params.value;
    this.inputElementClicked = true;
  }

  /* * * * * * * * *
   * Cell Focus event
   * * * * * * * * */
  cellFocusedEvent(params) {
    if (params.column && params.column.colId == "0") {
      this.gridOptions.suppressRowClickSelection = true;
    } else {
      this.gridOptions.suppressRowClickSelection = false;
    }
  }
  selectionChanged(params) {
  }

  rowSingleClicked(e) {
    if (window.innerWidth <= mobileWidth) {
      if (e.event.target.classList[0] == "tntIcon") {
        this.rowSelected(e);
      } else {
        this.rowDoubleClicked(e);
      }

    }
  }

  rowClicked(params) {
    this.rowSelected(params);
    //this.rowSingleClicked(params);
  }

  /* * * * * *
  * Cell Value changed save it by clicking other Row/Col
  * * * * * */
  onCellValueChanged(params) {
    this.rowNodeIndex = 0;
    this.oldValue = params.oldValue;
    this.newValue = params.newValue;
    this.columnId = params.column.getId();
    this.rowNodeIndex = params.rowIndex;
  }
  clickNav(e) {
    if (this.currentScreenProps.componentName !== 'FormGridComponent') {
      this.driveServiceProvider.rowNode = this.gridOptions.api.getDisplayedRowAtIndex(e.rowIndex);
      this.chatTntActivity.emit(e);
      this.row_index = e;
    } else {
      this.driveServiceProvider.broadcastInfo({ src: 'drive-main', event: 'formGridTNTChat', index: e, templateID: this.currentScreenProps.id });
      this.row_index = e;
    }
  }

  updateData(e) {
    if (e.type == "update") {
      if (this.rowNodeIndex == e.rowIndex) {
        if (this.oldValue != this.newValue) {
          let data: any = e.rowData;
          this.objPostData = Object.assign({}, this.currentScreenProps.pushParams, data);
          this.driveServiceProvider.pushSyncData(0, this.objPostData, null, this.storeWrap.typeOfData.typePostCustomApi, this.editedDataSavedSuccessfully)
        }
      }
    } else if (e.type == "clear") {
      if (this.inputElementClicked == true) {
        this.inputElementClicked = false;
        if (this.rowNodeIndex == e.rowIndex) {
          if (this.oldValue != this.newValue) {
            let rowNode: any;
            rowNode = this.gridOptions.gridApi.getRowNode(e.rowIndex);
            rowNode.setDataValue(this.columnId, this.oldValue);
            this.oldValue = '';
            this.newValue = '';
          }
        }
      } else if (this.inputElementClicked == false) {
        let confirmAlert = this.alertCtrl.create({
          title: 'Confirm Delete',
          message: 'Do you want to delete the selected row?',
          buttons: [{
            text: 'Yes',
            handler: () => {
              let data: any = e.rowData;
              this.objDeletePostData = Object.assign({}, this.currentScreenProps.pushParams, data, { delete: "true" });
              this.driveServiceProvider.pushSyncData(0, this.objDeletePostData, null, this.storeWrap.typeOfData.typePostCustomApi, this.deletedRowStatus)
            }
          }, {
            text: 'No',
            role: 'cancel',
            handler: () => {
            }
          }]
        });
        confirmAlert.present();
      }
    }
  }

  editedDataSavedSuccessfully = ((data) => {
    const toast = this.toastCtrl.create({
      message: 'Row is edited Successfully.',
      duration: this.configApiService.toastDuration
    });
    toast.present();

    let rowNode: any;
    rowNode = this.gridOptions.gridApi.getRowNode(this.rowIndexEditStop);
    this.changedRowNode.push(rowNode);
    var params = {
      force: true,
      rowNodes: [rowNode]
    };

    this.gridOptions.api.refreshCells(params);
    this.oldValue = '';
    this.newValue = '';
    this.columnId = '';
    this.rowNodeIndex = 0;
  });

  deletedRowStatus = ((data) => {
    this.onRemoveSelected();
    const toast = this.toastCtrl.create({
      message: 'Row deleted successfully.',
      duration: this.configApiService.toastDuration
    });
    toast.present();
    this.driveServiceProvider.broadcastInfo({ src: 'form-grid', event: 'deleteRowRecord', staus: true });

    let rowNode: any;
    rowNode = this.gridOptions.gridApi.getRowNode(this.rowIndexEditStop);
    if (rowNode != undefined) {
      rowNode.setDataValue(this.columnId, this.rowEditStartValue);
    }
  })

  clearData = ((data) => {

  });

  onRemoveSelected() {
    var selectedData = this.gridOptions.gridApi.getSelectedRows();
    var res = this.gridOptions.gridApi.updateRowData({ remove: selectedData });
    this.successInsert(res);
  }
  /*************************************************************** */

  /************************** TOP MENU BUTTONS ****************************************/
  /*****
   * ADD NEW ENTRY
   * ******/
  addNewEntryForm(e) {
    if (this.currentScreenProps.componentName === 'FormGridComponent' || this.currentScreenProps.componentName === 'SUMMARY') {
      this.gridOptions.gridApi.deselectAll();
      this.driveServiceProvider.broadcastInfo({ src: 'form-grid', event: 'addNewRecordDefaultForm', screenProps: this.currentScreenProps, status: true });
    }
    else {
      this.driveServiceProvider.gridNewForm = true;
      let currentFolderTemplates = this.getCurrentFolderStoredTemplates();
      this.inlineEditAccess = currentFolderTemplates[0].colprops.find(col => col.editable == true);
      if (this.inlineEditAccess) {
        this.addNewRow();
      } else {
        let paramKeyVal: any = {};
        this.driveServiceProvider.broadcastInfo({ src: 'drive-main', event: 'showComponentHolder', status: true });
        paramKeyVal[currentFolderTemplates[0].sourceKey] = '0';
        setTimeout(() => {
          this.driveServiceProvider.broadcastInfo({ src: 'compLoad', event: 'triggerComponentLoad', status: 'newdata', item: currentFolderTemplates, param: paramKeyVal });
        }, 1000)
      }

    }

  }

  getCurrentFolderStoredTemplates() {
    let arrTemplateProps = [];
    if (this.driveServiceProvider.objCurrentFolder.template.length) { // changing the validation to 1 from >1
      for (let idx = 0; idx < this.driveServiceProvider.objCurrentFolder.template.length; idx++) {
        if (this.driveServiceProvider.objCurrentFolder.template[idx].id) {
          arrTemplateProps.push(this.driveServiceProvider.storeWrap.storeTemplates[this.driveServiceProvider.objCurrentFolder.template[idx].id]);
        }
      }
    }
    return arrTemplateProps;
  }

  /* * * * * *
  * Save Smart Folder
  * * * * * */
  saveSmartFolder(e) {
    let alert = this.alertCtrl.create({
      title: 'New Folder',
      inputs: [
        {
          name: 'FolderName',
          placeholder: 'Folder Name'
        }
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: data => {

          }
        },
        {
          text: 'Create',
          handler: data => {

            if (data.FolderName.trim()) {
              let foldername: any = this.driveServiceProvider.objCurrentFolder["folders"].find(item => item.name == data.FolderName);
              if (foldername) {
                const toast = this.toastCtrl.create({
                  message: 'Folder Name already exists. Please, create new foldername.',
                  duration: this.configApiService.toastDuration
                });
                toast.present();
                this.saveSmartFolder(e);
              } else {
                if (this.advanceSearchEnable != true) {
                  let filterParams = this.gridOptions.filterParams;
                  let filterData = {};
                  let objFilterParams = {};
                  let defaultOperator = 'AND'
                  Object.keys(filterParams).forEach(field => {
                    var filterParamsKeys = Object.keys(filterParams[field])
                    var filterParamsKeysCon = filterParamsKeys.filter(s => s.includes('con'));
                    if (filterParamsKeysCon.length > 0) {
                      filterParamsKeysCon.forEach(objData => {
                        filterParams[field][objData]['operator'] = filterParams[field]['operator'];
                      })
                      delete filterParams[field]['operator'];
                    } else {
                      filterData[field] = {};
                      filterParams[field]['operator'] = defaultOperator;
                      filterData[field]['condition1'] = filterParams[field];
                      filterData[field]['filterType'] = filterParams[field]['filterType'];
                      delete filterData[field]['filter'];
                      delete filterData[field]['operator'];
                      delete filterData[field]['type'];
                    }
                    objFilterParams = Object.assign({}, filterParams, filterData)
                  })

                  this.gridOptions.filterParams = objFilterParams;
                }
                this.driveServiceProvider.createSmartFolder(data.FolderName, this.gridOptions.filterParams);
              }
            } else {
              const toast = this.toastCtrl.create({
                message: 'Folder Name cannot be empty.',
                duration: this.configApiService.toastDuration
              });
              toast.present();
              this.saveSmartFolder(e);
            }
          }
        }
      ]
    });
    alert.present();
  }
  /**************************************************** */

  shareData(event) {
    if (this.currentScreenProps.template != undefined && this.currentScreenProps.template.length == 0) {
      this.currentScreenProps.template = JSON.parse(this.driveServiceProvider.objBckupObjFolerProperties)['template']
    }
    let selectedFile = this.gridOptions.gridApi.getSelectedRows();
    var folderProperty;
    var templateInfo;
    var selectedRow = [];
    if (selectedFile.length > 0) {
      this.driveServiceProvider.objCurrentFolder['files'] = [];
      let formGridTemplate: any = [];
      if (this.currentScreenProps.componentName === 'FormGridComponent' || this.currentScreenProps.componentName === "SUMMARY") {
        formGridTemplate.push({ 'id': this.currentScreenProps['id'], 'filterParams': this.currentScreenProps.filterParams });
        folderProperty = {
          'template': formGridTemplate
        }
        templateInfo = formGridTemplate;
      } else {
        folderProperty = {
          'template': this.driveServiceProvider.objCurrentFolder.template
        }
        templateInfo = this.driveServiceProvider.objCurrentFolder.template;
      }
      selectedRow.push({ [this.storeWrap.storeTemplates[templateInfo[0].id].sourceKey]: selectedFile[0][this.storeWrap.storeTemplates[templateInfo[0].id].sourceKey] });


      let data = Object.assign({}, this.configApiService.driveApi.pushLinkShareUser.params, {
        "RecordID": selectedFile[0][this.currentScreenProps.sourceKey],
        "ShareID": '',
        "ShareType": 'File',
        "TemplateID": this.currentScreenProps.id,
        "TemplateName": this.currentScreenProps.templateName,
        "userid": this.configureService.getLoginUserID(),
        "SharedInfo": { 'rowData': selectedFile, 'sharedFolder': folderProperty, 'senderId': this.configureService.getLoginData()['user'], 'accessType': 'public', 'pullFolderTemplate': { "client": this.configureService.getStudio(), 'userid': this.configureService.getLoginUserID(), 'app_code': this.configApiService.currentDriveApp['app_code'], 'currentAppDetails': this.configApiService.currentDriveApp, "LoginUserDetails": this.driveServiceProvider.LoginUserDetails } }
      });
      var modalPage = this.modal.create(DriveSharePage, { 'shareDataSet': data, "ShareType": 'File', 'ShareID': '', 'currentFolderTemplate': this.currentScreenProps['templateName'], 'selectedRowData': selectedFile, "ComponentName": this.currentScreenProps.componentName }, { cssClass: "data_Share", showBackdrop: true, enableBackdropDismiss: false });
      modalPage.present();
      var ObjLen = 0;
      modalPage.onDidDismiss(data => {
        if (data && Object.keys(data).length != ObjLen && data.Field != '' && data.link != '') {
          this.refreshData()
        }
      });
    } else {
      const toast = this.toastCtrl.create({
        message: 'Please select any row.',
        duration: this.configApiService.toastDuration
      });
      toast.present();
    }
  }

  /* * * * * *
 * send mail 
 * * * * * */
  sendMail(event) {
    let selectedFile = this.gridOptions.gridApi.getSelectedRows();
    this.driveServiceProvider.objCurrentFolder['files'] = [];
    let data = Object.assign({}, this.configApiService.driveApi.pushLinkShareUser.params, {
      "ShareID": '',
      "ShareType": 'File',
      "SharedInfo": { 'rowData': selectedFile, 'sharedFolder': this.driveServiceProvider.objCurrentFolder, 'recipientMailId': '', 'accessType': 'public' }
    })
    if (selectedFile.length > 0) {
      var modalPage = this.modal.create(SchedulerPage, { 'shareDataSet': data, "ShareType": 'File', 'ShareID': '', 'currentFolderTemplate': this.currentScreenProps['templateName'], 'selectedRowData': selectedFile }, { cssClass: "scheduler_class" });
      modalPage.present();
      modalPage.onDidDismiss(data => {

      });
    }
    else {
      const toast = this.toastCtrl.create({
        message: 'Please select any row.',
        duration: this.configApiService.toastDuration
      });
      toast.present();
    }
  }


  /* * * * * *
  * Export Data File
  * * * * * */
  exportData() {
    var params = {
      fileName: 'dataExport_' + new Date()
    }
    this.gridOptions.api.exportDataAsCsv(params);
  }
  /**************************************************** */
  getParamValueQueryString() {
  }
  /* * * * * *
  * Print Data File
  * * * * * */
  printData() {
    var gridApi = this.gridOptions.api;
    var rowCount = gridApi.getDisplayedRowCount();
    var lastGridIndex = rowCount - 1;
    var currentPage = gridApi.paginationGetCurrentPage();
    var pageSize = gridApi.paginationGetPageSize();
    var endPageIndex = (currentPage + 1) * pageSize - 1;
    if (endPageIndex > lastGridIndex) {
      endPageIndex = lastGridIndex;
    }
    this.setPrinterFriendly(gridApi);
    setTimeout(function () {
      print();
      this.pagination = true;
      gridApi.setDomLayout(null);
    }, 2000);
  }

  setPrinterFriendly(api) {

    api.setDomLayout("print");
  }

  setNormal(api) {
    var eGridDiv = document.querySelector("#listGridData");
    eGridDiv['style'].width = "100%";
    eGridDiv['style'].height = "95%";
    this.pagination = true;
    api.setDomLayout(null);
  }

  /**********
  * Refresh Feature
  * ************* */
  refreshData() {
    this.fetchScreenProps();
    if (this.driveServiceProvider.objCurrentFolder != undefined) {
      var params = { force: true };
      this.gridOptions.gridApi.setFilterModel(null);
      this.gridOptions.gridApi.refreshCells(params);
      this.gridOptions.filterChange = true;
      this.quickSearchValue = "";
      this.gridOptions.api.setQuickFilter(this.quickSearchValue);
      this.rowselectedLength = 0;
      if (this.groupShare == undefined) {
        this.driveServiceProvider.CurrentFilesData = [];
        this.driveServiceProvider.pullSyncData(this.templateID, this.params, this.driveServiceProvider.objCurrentFolder, this.storeWrap.typeOfApi.summary, this.storeWrap.typeOfData.typeFile, this.getFileData)
      }
      this.showOpen = false;
    }
  }

  getFileData = ((data) => {
    if (data.length > 0) {
      if (data != undefined) {
        if (this.gridOptions.api != null) {
          // this.gridOptions.api.showLoadingOverlay();
        }
        this.setGridData(data);
      }
    }
  });

  setGridData(data) {
    const RECORDSLENGTH = 1000
    if (!this.isLoadMoreClick) {
      this.driveServiceProvider.CurrentFilesData = [];
    }
    if (this.driveServiceProvider.CurrentFilesData.length == OBJLEN) {
      this.driveServiceProvider.CurrentFilesData = data[OBJLEN];
    } else {
      if (data[OBJLEN].length > OBJLEN && this.isLoadMoreClick == true) {
        data[OBJLEN].forEach(element => {
          this.driveServiceProvider.CurrentFilesData.push(element);
        });
      } else if (data[OBJLEN].length == OBJLEN) {
        const toast = this.toastCtrl.create({
          message: 'Maximum records Reached.',
          duration: this.configApiService.toastDuration
        });
        toast.present();
      }
    }
    let gridApi: any;
    if (this.gridOptions.api) {
      this.gridOptions.api.setRowData(this.driveServiceProvider.CurrentFilesData);
      this.gridAllRows = JSON.stringify(this.driveServiceProvider.CurrentFilesData)
      var params = { force: true, rowNodes: this.changedRowNode };
      gridApi = this.gridOptions.api;
      gridApi.refreshCells(params);
      this.gridOptions.api.hideOverlay()
    }
    if (this.watchTabStatus == true) {
      let activityData = {};
      this.rowIndex = this.driveServiceProvider.CurrentFilesData.findIndex(item => item[this.currentScreenProps.sourceKey] == this.driveServiceProvider.watchTabFolderProps['recordID'])
      var node = this.gridOptions.api.getRowNode(this.rowIndex);
      node.setSelected(true);
      let objData = this.driveServiceProvider.CurrentFilesData.filter(item => item[this.currentScreenProps.sourceKey] == this.driveServiceProvider.watchTabFolderProps['recordID'])
      activityData['rowData'] = objData[OBJLEN]
      activityData['rowIndex'] = this.rowIndex;
      this.chatTntActivity.emit(activityData);
      this.row_index = activityData;
      this.watchTabStatus = false;
    }
    const RECORDSLEN = 999;
    if (this.driveServiceProvider.CurrentFilesData.length > RECORDSLEN && data[OBJLEN].length >= RECORDSLENGTH) {
      this.loadMoreIcon = '';
    } else {
      this.loadMoreIcon = 'disableLoadMoreIcon';
    }
    if (this.gridOptions.api != null) {
      this.gridOptions.api.hideOverlay()
    }
  }
  /************
   * Quick Filter 
   * *********** */
  onQuickFilterChanged() {
    this.gridOptions.api.setQuickFilter(this.quickSearchValue);
    if (this.quickSearchValue.length > 0) {
      this.gridOptions.filterChange = false;
    }
    else {
      this.gridOptions.filterChange = true;
    }
  }

  /********
   * Pagination
   * ******* */
  onPageSizeChanged(newPageSize) {
    var value = this.pageSize;
    this.gridOptions.gridApi.paginationSetPageSize(Number(value));
  }
  /************************** TOP MENU BUTTONS END****************************************/


  /**************************************************** */
  ngAfterViewChecked() {
    if (this.tntActiveStatus == true) {
      this.gridOptions.suppressRowClickSelection = false;
    }
    this.cdRef.detectChanges();
  }
  ngAfterViewInit() {
    var obj = {
      eventName: "driveConnectionEstablished"
    }
    window.parent.postMessage(obj, '*');

    window.addEventListener('message', (event) => {
      var obj = event.data;
      if (obj.eventName === "pullDriveData") {
        var _obj = {
          eventName: "pushDriveData",
          data: this.driveServiceProvider.objCurrentFolder.files[0],
        }
        window.parent.postMessage(_obj, '*');
      }
    });

    window.addEventListener('message', (event) => {
      var obj = event.data;
      if (obj.eventName === "pushExcelDataToDrive") {

        let data = JSON.stringify(obj.data);
        data = JSON.parse(data);
        let pushData = this.fetchExcelData(data);
        this.pushExcelData(pushData);
      }
      if (event.data.src == "sharePopupClose") {
        this.loadGridData(this.templateID);
      }
    });
  }

  /* * * * * *
  * push data
  * * * * * */
  pushExcelData(pushData) {
    let obj = {
      PushArray: pushData
    };
    let pushParams = this.driveServiceProvider.storeWrap.storeTemplates[this.templateID].pushParams;
    let params = { client: pushParams.client, rptname: pushParams.rptname, userid: pushParams.userid }
    var objData = Object.assign({}, params, obj);
    jQuery("#out").append("pushData " + pushData + ' <br>')
    this.configApiService.pushRequest(objData, this.excelPushSucess)
  }

  excelPushSucess = ((resData) => {
    alert("Excel Record Pushed !!");
    const toast = this.toastCtrl.create({
      message: 'Excel Record Pushed.',
      duration: this.configApiService.toastDuration
    });
    toast.present();
    this.refreshData()
  });

  /* * * * * *
  * get push param 
  * * * * * */
  getPushParamKeys(pushParam) {
    var item = {};
    Object.keys(pushParam).forEach(function (key) {
      if (key != 'userid' && key != 'client') {
        item[key] = pushParam[key];
      }
    });
    return item;
  }

  /* * * * * *
  * method for multiple templates push data handle 
  * * * * * */
  fetchExcelData(excelData) {
    var pushData = [];
    let pushParams = this.driveServiceProvider.storeWrap.storeTemplates[this.templateID].pushParams;
    let pushParam = this.getPushParamKeys(pushParams);
    excelData.forEach((excelDataItem) => {
      var item = {};
      Object.keys(excelDataItem).forEach(function (dataKey) {
        Object.keys(pushParam).forEach(function (pushParamKey) {
          if (dataKey === pushParamKey) {
            item[pushParamKey] = excelDataItem[pushParamKey];
          }
        })
      })
      var _item = Object.assign({}, pushParam, item);
      pushData.push(_item);
    });
    return pushData;
  }

  onRowDragEnter(params) {

  }

  onRowDragEnd(e) {

  }

  onRowDragMove(e) {

  }

  onRowDragLeave(e) {

  }

  alert: any;
  deleteRows() {
    let selectedRowData = this.gridOptions.api.getSelectedRows();
    if (selectedRowData.length > 0) {
      this.actionStatus = "delete";
      this.alert = this.alertCtrl.create({
        title: 'Confirm Delete',
        message: 'Do you want to delete the selected row?',
        buttons: [{
          text: 'Yes',
          handler: () => {
            this.onRemoveSelected();
            let template = this.templateID;
            const ObjIdx = 0;
            const ObjLen = 1;
            var sourceKey = this.storeWrap.storeTemplates[template]['sourceKey']
            var deleteData = []
            var deleteKey: any = []
            if (selectedRowData.length > ObjLen) {
              selectedRowData.forEach(element => {
                deleteKey = Object.keys(element).filter(ele => ele == sourceKey)
                deleteData.push({ [deleteKey]: element[deleteKey[ObjIdx]] });
              })
              this.driveServiceProvider.deleteMultiRecords(deleteData, template);
            } else {
              if (this.storeWrap.storeTemplates[template]['actionKey'] == '') {
                this.storeWrap.storeTemplates[template]['actionKey'] = 'status'
              }
              this.driveServiceProvider.deleteData(template, selectedRowData[ObjIdx], null, this.storeWrap.typeOfData.typePostCustomApi, this.deletedRowStatus);
            }
          }
        }, {
          text: 'No',
          role: 'cancel',
          handler: () => {

          }
        }]
      });
      this.alert.present();
    } else {
      const toast = this.toastCtrl.create({
        message: 'Please select any row.',
        duration: this.configApiService.toastDuration
      });
      toast.present();
    }
  }

  importData() {
    this.excelService.currentTemplateProperty = JSON.stringify(this.currentScreenProps)
    this.excelService.currentFolderProperty = JSON.stringify(this.driveServiceProvider.objCurrentFolder)
    // var modalPage = this.modal.create(ExcelUploadPage, { 'currentFolderTemplate': this.currentScreenProps });
    // setTimeout(()=>{
    //   modalPage.present();
    // });
    let popover = this.popoverCtrl.create(ExcelUploadPage, { 'currentFolderTemplate': this.currentScreenProps });
    popover.present();
    popover.onDidDismiss(data => {
      if (data == true) {
        this.driveServiceProvider.CurrentFilesData = [];
        if (Object.keys(this.excelService.driveService.formGridTempProps).length != 0) {
          this.rowDataStatus = false;
          this.refreshData();
        } else {
          this.loadGridData(this.templateId)
        }
        this.excelService.resetTemplateFields()
      }
    })
  }
  longpress(e) {

  }

  setVersionHistory(pushData) {
    if (this.configApiService.driveApi.pushDocStatus != undefined) {
      let regUserId = this.configureService.getLoginUserID();
      let pushParams: any = '';
      let obj = {
        PushArray: pushData
      };
      pushParams = this.configApiService.driveApi.pushDocStatus.params;
      let params = { client: pushParams.client, userid: regUserId }
      var objData = Object.assign({}, params, obj)
      this.configApiService.pushRequest(objData, this.submitSucess);
    }
  }

  submitSucess = ((resData) => {

  });
  listMenu() {
    this.show = !this.show;
  }
  resizeGridMenu(e) {
    this.gridReSize = !this.gridReSize;
  }

  @ViewChild("resizeInsideElement", { static: true }) resizeInsideElement;
  @HostListener('document:click', ['$event.target'])
  public onClick(targetElement) {
    if (targetElement.parentElement != null) {
      if (targetElement.parentElement.parentElement.id == "gridMenuList" || targetElement.id == "gridMenu" || targetElement.parentElement.id == "gridMenuList") {
      } else {
        if (this.gridReSize) {
          this.gridReSize = false;
        }
      }
    }
    if (this.resizeInsideElement != undefined) {
      const clickedInside = this.resizeInsideElement.nativeElement.contains(targetElement);
      if (!clickedInside) {
        if (this.mobilView != true) {
          this.gridReSize = false;
        }
      }
    }
    if (targetElement.id != 'showGridOpt') {
      this.show = false;
    }
  }
  loadGridTemplateManager(e) {
    this.gridOptions.columnDefs = e["colprops"];
  }
  saveTemplateManager(e) {
    this.triggerTemplateManager.emit(this.gridOptions)
    return
  }

  getFields() {
    this.arrTemplateFields = this.driveServiceProvider.storeWrap.storeTemplates[this.templateID]["formLayout"][0][0]["fields"];
    let folderId = this.driveServiceProvider.objCurrentFolder["folder_id"];
    let folderName = this.driveServiceProvider.objCurrentFolder["name"]
    this.tempFields = { 'fields': this.arrTemplateFields, 'templateId': this.templateID, 'folderId': folderId, 'folderName': folderName };
    this.getTempFieldProp();
    this.openAdvSearchWindow();
  }

  getTempFieldProp() {
    var data = {};
    for (var i = 0; i < Object.keys(this.storeWrap.storeTemplates[this.templateID].pullParams).length; i++) {
      if (Object.keys(this.storeWrap.storeTemplates[this.templateID].pullParams)[i] != 'start' && Object.keys(this.storeWrap.storeTemplates[this.templateID].pullParams)[i] != 'end') {
        data[Object.keys(this.storeWrap.storeTemplates[this.templateID].pullParams)[i]] = this.storeWrap.storeTemplates[this.templateID].pullParams[Object.keys(this.storeWrap.storeTemplates[this.templateID].pullParams)[i]];
      }
    }
    this.configApiService.fieldpropertyRequest(data, (_respData) => {
      this.tempFieldProperties = _respData;
    })
  }

  openAdvSearchWindow() {
    const ObjLen = 0;
    var modalPage = this.modal.create(AdvanceSearchComponent, { 'templatefields': this.tempFields, 'fieldProperties': this.tempFieldProperties, 'templateID': this.templateID, 'currentFolder': this.driveServiceProvider.objCurrentFolder, "params": this.params }, { cssClass: "advanceSearch", showBackdrop: true, enableBackdropDismiss: false });
    modalPage.present();

    // const ObjLen = 0;
    // let popover = this.popoverCtrl.create(AdvanceSearchComponent, { 'templatefields': this.tempFields, 'fieldProperties': this.tempFieldProperties, 'templateID': this.templateID, 'currentFolder': this.driveServiceProvider.objCurrentFolder, "params": this.params }, { cssClass: "advanceSearch", showBackdrop: true, enableBackdropDismiss: false });
    // setTimeout(()=>{
    // popover.present();
    // })
    modalPage.onDidDismiss(data => {
      if (data && data.length != ObjLen && Object.keys(data).length != ObjLen) {
        this.searchFlag = data.flag;
        if (data.filterParams['length'] != ObjLen) {
          this.driveServiceProvider.CurrentFilesData = [];
          this.getFileData(data.rowsData);
          if (Object.keys(data.filterParams).length != 0) {
            this.gridOptions.filterChange = false;
            this.advanceSearchEnable = true;
          } else {
            this.gridOptions.filterChange = true;
          }
          this.gridOptions.filterParams = data.filterParams;
          this.filterparams = data.filterParams
        } else {
          this.refreshData();
        }
      }
    });
  }

  loadMoreRecords() {
    this.presentLoading();
    this.isLoadMoreClick = true;
    let templateID = this.driveServiceProvider.objCurrentFolder.template[0].id;
    const STARTLEN = 1;
    const ADDLEN = 1000;
    //this.driveServiceProvider.objCurrentFolder.template[0].filterParams = this.filterparams
    var startvalue = this.gridOptions.gridApi.paginationGetRowCount() + STARTLEN;
    var endvalue = this.gridOptions.gridApi.paginationGetRowCount() + ADDLEN;
    this.storeWrap.storeTemplates[templateID].pullParams.start = startvalue;
    this.storeWrap.storeTemplates[templateID].pullParams.end = endvalue;
    this.driveServiceProvider.pullSyncData(templateID, this.params, this.driveServiceProvider.objCurrentFolder, this.storeWrap.typeOfApi.summary, this.storeWrap.typeOfData.typeFile, this.getFileData);
    //this.driveServiceProvider.objCurrentFolder.template[0].filterParams = {}
    this.loader.dismiss();
  }
  activateRunRule() {
    const arrayIdx = 0;
    let objAppCode = this.currentScreenProps["pullParams"]["client"];
    let obj = {
      "workflow": this.WorkflowID,
      "client": objAppCode
    }
    var objData = Object.assign({}, this.configApiService.driveApi.runRule.params, obj)
    let alert = this.alertCtrl.create({
      title: 'Do You Want Run The Rule..?',
      buttons: [
        {
          text: 'Yes',
          handler: data => {
            this.configApiService.customRequest(this.configApiService.runRuleApi, objData, this.submitRunruleSucess)
            alert.dismiss();
            return false
          }
        },
        {
          text: 'No',
          handler: data => {
            alert.dismiss();
            return false
          }
        }
      ]
    });
    alert.present();
  }


  getAllRules() {
    let folderId = this.driveServiceProvider.objCurrentFolder['folder_id'];
    if (this.driveServiceProvider.objFolderRules[folderId] != undefined) {
      let ruleData = this.driveServiceProvider.objFolderRules[folderId];
      this.setRules(ruleData);
    } else {
      let pullSummaryData = {
        "FolderInfo": folderId
      }
      var objData = Object.assign({}, this.configApiService.driveApi.SummaryAllRules.params, pullSummaryData, { "client": this.configureService.getStudio(), 'userid': this.configureService.getLoginUserID() })
      this.configApiService.pullRequest(objData, this.submitAllRules);
    }
  }

  submitAllRules = ((data) => {
    let folderId = this.driveServiceProvider.objCurrentFolder['folder_id']
    if (data['length'] != 0) {
      this.driveServiceProvider.objFolderRules[folderId] = data;
      this.setRules(data);
    } else {
      const toast = this.toastCtrl.create({
        message: 'Sorry!..There is No Rules in this Folder',
        duration: this.configApiService.toastDuration,
        position: 'bottom'
      });
      toast.present();
    }
  })

  setRules(data) {
    this.newRulearr = data;
    this.newRuleLength = this.newRulearr.length - 1;
    this.WorkflowID = data[0]["WorkflowID"];
    if (this.currentScreenProps.componentName === 'FormGridComponent' && this.driveServiceProvider.CurrentFilesData.length == 0) {
      var dataset = []
      dataset.push(this.driveServiceProvider.CurrentFilesData)
      this.setGridData(dataset)
    }
  }

  submitRunruleSucess = ((resData) => {
    if (resData["_POST_RunWorkflowResult"] == "SUCCESS") {
      const toast = this.toastCtrl.create({
        message: 'Enabeled Rule Excuted Successfully.',
        duration: this.configApiService.toastDuration,
        position: 'bottom'
      });
      toast.present();
      return resData;
    }
  })

  toHideGridColumns() {
    var fields = this.currentScreenProps.formLayout[0][0].fields
    this.gridOptions.columnDefs.forEach(element => {
      fields.forEach(elem => {
        if (element.headerName == elem.FieldName && elem.IsGrid && elem.IsGrid == '0') {
          element.hide = true;
        }
      })
      if (element.FieldDataType == "HYPERLINK") {
        element.cellRenderer = 'hyperLinkRenderer'
      }
    });
  }

  initDriveEvents() {
    this.broadcastSubs = this.communicationServ.getInstance()
      .subscribe((data: any) => {
        if (data.src === "grid-main") {
          if (data.event === 'ediableGrid') {
            this.addNewRow();
          } else if (data.event === 'triggerGridComponentLoad') {
            let status = data['status'];
            let rowData = data['rowData']
            if (status === true) {
              this.driveServiceProvider.CurrentFilesData = rowData
              this.gridOptions.gridApi.setRowData(rowData);
              this.showOpen = false;
            }
          } else if (data.event === 'updatedFormStatus') {
            let paramId = data['paramId'];
            let templateProperty = data['templateProperty'];
            if (this.gridOptions.api != null) {
              this.gridOptions.api.forEachNode(node => node.rowIndex == this.selectedGirdRow.rowIndex ? node.setSelected(true) : '')
            }
          } else if (data.event === 'versionHistroryStatus') {
            let status = data['status'];
            if (window.innerWidth <= this.screenResolution) {
              if (status == 'open') {
                this.min_window = true;
              } else if (status == 'close') {
                this.min_window = false;
              }
            }
          } else if (data.event === 'gridRefresh') {
            this.refreshData();
          }
        }
        if (data.src === "drive") {
          if (data.event === 'tntActiveStatusClose') {
            let status = data['status'];
            if (status == true) {
              this.tntActiveStatus = status;
            } else {
              this.gridOptions.gridApi.deselectAll();
            }

          }
        }
        if (data.src === "versionPanel") {
          if (data.event === 'RefreshStatus') {
            // let status = data['status'];
            let selectedData = this.row_index;
            selectedData.rowData.status = data['status']['status'];
            var rowNode = this.gridOptions.api.getDisplayedRowAtIndex(selectedData.rowIndex);
            rowNode = rowNode != undefined ? rowNode : this.driveServiceProvider.rowNode;
            var params = { force: true, rowNodes: [rowNode] };
            this.gridOptions.gridApi.refreshCells(params);
          }
        }
      })
  }

  presentLoading() {
    this.loader = this.loadingController.create({
      spinner: 'ios',
      content: 'Processing Please wait...'
    });
    this.loader.present();
  }

}




// WEBPACK FOOTER //
// ./src/components/my-grid-application/my-grid-application.ts